/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../index";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createDocsInsightsReport = /* GraphQL */ `mutation CreateDocsInsightsReport($input: CreateDocsInsightsReportInput!) {
  createDocsInsightsReport(input: $input) {
    isSuccess
    message
    requestId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDocsInsightsReportMutationVariables,
  APITypes.CreateDocsInsightsReportMutation
>;
export const createDocumentUrl = /* GraphQL */ `mutation CreateDocumentUrl($input: CreateDocumentUrlInput!) {
  createDocumentUrl(input: $input) {
    url
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDocumentUrlMutationVariables,
  APITypes.CreateDocumentUrlMutation
>;
export const createFormPDF = /* GraphQL */ `mutation CreateFormPDF($input: CreateFormPDFUrlInput!) {
  createFormPDF(input: $input) {
    url
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFormPDFMutationVariables,
  APITypes.CreateFormPDFMutation
>;
export const deleteDocument = /* GraphQL */ `mutation DeleteDocument($input: DeleteDocumentInput!) {
  deleteDocument(input: $input) {
    deviceId
    documentName
    serialId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDocumentMutationVariables,
  APITypes.DeleteDocumentMutation
>;
export const deleteKintoneSetting = /* GraphQL */ `mutation DeleteKintoneSetting {
  deleteKintoneSetting
}
` as GeneratedMutation<
  APITypes.DeleteKintoneSettingMutationVariables,
  APITypes.DeleteKintoneSettingMutation
>;
export const deleteLinkServiceToken = /* GraphQL */ `mutation DeleteLinkServiceToken($input: DeleteLinkServiceTokenInput!) {
  deleteLinkServiceToken(input: $input)
}
` as GeneratedMutation<
  APITypes.DeleteLinkServiceTokenMutationVariables,
  APITypes.DeleteLinkServiceTokenMutation
>;
export const enabledTenantFeatureSetting = /* GraphQL */ `mutation EnabledTenantFeatureSetting(
  $input: EnabledTenantFeatureSettingtInput!
) {
  enabledTenantFeatureSetting(input: $input) {
    id
    name
    state
    enablingMessage
    enabledMessage
    disablingMessage
    disabledMessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.EnabledTenantFeatureSettingMutationVariables,
  APITypes.EnabledTenantFeatureSettingMutation
>;
export const getLinkServiceToken = /* GraphQL */ `mutation GetLinkServiceToken($input: GetLinkServiceTokenInput!) {
  getLinkServiceToken(input: $input) {
    accessToken {
      token
      expiredDate
      __typename
    }
    endpointUrl
    __typename
  }
}
` as GeneratedMutation<
  APITypes.GetLinkServiceTokenMutationVariables,
  APITypes.GetLinkServiceTokenMutation
>;
export const getOAuthStateAndDelete = /* GraphQL */ `mutation GetOAuthStateAndDelete($input: GetOAuthStateAndDeleteInput!) {
  getOAuthStateAndDelete(input: $input) {
    state
    __typename
  }
}
` as GeneratedMutation<
  APITypes.GetOAuthStateAndDeleteMutationVariables,
  APITypes.GetOAuthStateAndDeleteMutation
>;
export const kintoneRestAPIWrapper = /* GraphQL */ `mutation KintoneRestAPIWrapper($input: KintoneRestAPIWrapperInput) {
  kintoneRestAPIWrapper(input: $input) {
    kintoneResponse
    __typename
  }
}
` as GeneratedMutation<
  APITypes.KintoneRestAPIWrapperMutationVariables,
  APITypes.KintoneRestAPIWrapperMutation
>;
export const linkServiceTokenGeneratedFromCode = /* GraphQL */ `mutation LinkServiceTokenGeneratedFromCode(
  $input: LinkServiceTokenGeneratedFromCodeInput
) {
  linkServiceTokenGeneratedFromCode(input: $input) {
    accessToken {
      token
      expiredDate
      __typename
    }
    refreshToken {
      token
      expiredDate
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.LinkServiceTokenGeneratedFromCodeMutationVariables,
  APITypes.LinkServiceTokenGeneratedFromCodeMutation
>;
export const permanentlyDeleteDocument = /* GraphQL */ `mutation PermanentlyDeleteDocument($input: PermanentlyDeleteDocumentInput!) {
  permanentlyDeleteDocument(input: $input) {
    documentName
    serialId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PermanentlyDeleteDocumentMutationVariables,
  APITypes.PermanentlyDeleteDocumentMutation
>;
export const receiveEWBCIResponse = /* GraphQL */ `mutation ReceiveEWBCIResponse($input: EWBCIResponseInput!) {
  receiveEWBCIResponse(input: $input) {
    userId
    sessionId
    requestId
    requestedAt
    responsedAt
    serialId
    deviceId
    api
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ReceiveEWBCIResponseMutationVariables,
  APITypes.ReceiveEWBCIResponseMutation
>;
export const registerKintoneSetting = /* GraphQL */ `mutation RegisterKintoneSetting($input: RegisterKintoneSettingInput!) {
  registerKintoneSetting(input: $input)
}
` as GeneratedMutation<
  APITypes.RegisterKintoneSettingMutationVariables,
  APITypes.RegisterKintoneSettingMutation
>;
export const registerLinkServiceToken = /* GraphQL */ `mutation RegisterLinkServiceToken($input: RegisterLinkServiceTokenInput!) {
  registerLinkServiceToken(input: $input)
}
` as GeneratedMutation<
  APITypes.RegisterLinkServiceTokenMutationVariables,
  APITypes.RegisterLinkServiceTokenMutation
>;
export const registerOAuthState = /* GraphQL */ `mutation RegisterOAuthState($input: RegisterOAuthStateInput!) {
  registerOAuthState(input: $input)
}
` as GeneratedMutation<
  APITypes.RegisterOAuthStateMutationVariables,
  APITypes.RegisterOAuthStateMutation
>;
export const restoreDocument = /* GraphQL */ `mutation RestoreDocument($input: RestoreDocumentInput!) {
  restoreDocument(input: $input) {
    documentName
    serialId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RestoreDocumentMutationVariables,
  APITypes.RestoreDocumentMutation
>;
export const sendDocument = /* GraphQL */ `mutation SendDocument($input: SendDocumentInput!) {
  sendDocument(input: $input) {
    documentName
    serialId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SendDocumentMutationVariables,
  APITypes.SendDocumentMutation
>;
export const sendEWBCIRequest = /* GraphQL */ `mutation SendEWBCIRequest($input: EWBCIRequestInput!) {
  sendEWBCIRequest(input: $input) {
    userId
    sessionId
    requestId
    requestedAt
    serialId
    deviceId
    api
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SendEWBCIRequestMutationVariables,
  APITypes.SendEWBCIRequestMutation
>;
export const updateAiUsage = /* GraphQL */ `mutation UpdateAiUsage($input: UpdateAiUsageInput!) {
  updateAiUsage(input: $input) {
    aiServiceName
    month
    usageCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAiUsageMutationVariables,
  APITypes.UpdateAiUsageMutation
>;
